
$(document).ready(function(){  
  
  //Homepage owl carousel
//    $('.home-banner-carousel').owlCarousel({
//         loop:true,
//         autoplay:true,
//         autoplayTimeout:3000,
//         margin:10,
//         nav:true,
//         items : 1,
//         // autoplay: true,
//         responsive:{
//             0:{
//                 items:1
//             },
//             600:{
//                 items:1
//             },
//             1000:{
//                 items:1
//             }
//         }
//     });
  
$('.home-banner-carousel').slick({
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000
});   
  
// $('#owl-carousel-mobile').slick({
//     arrows: false,
//     dots: true,
//     infinite: true,
//     autoplay: true,
//     autoplaySpeed: 4000
// });  
  
//     $('#owl-carousel-mobile').owlCarousel({
//         loop:true,
//         margin:10,
//         nav:true,
//         autoplay: true,
//         responsive:{
//             0:{
//                 items:1,
//                 loop:true
//             },
//             600:{
//                 items:1
//             },
//             1000:{
//                 items:1
//             }
//         }
//     })  
   
    // wow js
    wow.init()

    $('.need-help').on('click',function(){
        $('a.crisp-kquevr')[0].click();
    });


    $(".dropdown").hover(            
        function() {
            $('.dropdown-menu', this).not('.in .dropdown-menu').stop(true,true).slideDown("400");
            $(this).toggleClass('open');        
        },
        function() {
            $('.dropdown-menu', this).not('.in .dropdown-menu').stop(true,true).slideUp("400");
            $(this).toggleClass('open');       
        }
    );
 
    $(".product-media-image").on("click", (function(event) {
        event.stopPropagation();
        $(".product-media, body").toggleClass("product-media-show");
        var t = $("html body");
        scrollTo(document.body, t.offsetTop, 50)
    }));
    $(".close-product-view").click(function(){
        $(".product-media, body").removeClass("product-media-show");
    })

    if ($(this).find('img').attr('data-zoom')) {
        $('.image-zoom')
        .wrap('<span style="display:inline-block"></span>')
        .css('display', 'block')
        .parent()
        .zoom({
          url: $(this).find('img').attr('data-zoom')
        });
    }

    try {
      
        $(window).on('unload', function(){
              $.cookie('scrollTop',$(window).scrollTop());
        });
      
    } catch (err) {
        console.error(err)
    }
    
    
    $('#men_owl_carousel_one').owlCarousel({
        loop:true,
        margin:10,
        nav:true,
        // autoplay: true, 
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
        }
    })
    $('#owl_men_carousel').owlCarousel({
        loop:false,
        margin:10,
        nav:true,
        items : 1,
        // autoplay: true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
        }
    })
    $('#owl_men_carousel_mobile').owlCarousel({
        loop:false,
        margin:10,
        nav:true,
        items : 1,
        // autoplay: true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
        }
    })



    video_popup();
    //collum 2 or 3 loop function
    inner3Col();



    $('#sort_by').change(function(){
        console.log("holaaaaa");
    //    var myValue =   $(this);
    //    console.log(myValue);
            localStorage.setItem('mySelectLocalstorageValue', $(this).val());
    });
    var selectedValue = localStorage.getItem('mySelectLocalstorageValue');
    console.log(selectedValue);
   $("."+ selectedValue).attr("selected"," selected");
    
    document.addEventListener("DOMContentLoaded", function() {
        var endlessScroll = new Ajaxinate({
            container: '#AjaxinateLoop',
            pagination: '#AjaxinatePagination',
            method: 'scroll',
            callback: null,
            loadingText: '<img src="https://cdn.shopify.com/s/files/1/0276/3836/6317/files/Loading_icon_f8500fa4-1fe1-4171-af40-1242676136fd.png?v=1579781631" width="200px" alt="">',
            offset: 0
        });
    });
    //owl carousel
    $("#owl_about_main_slider").owlCarousel({
        navigation : true, // Show next and prev buttons
        slideSpeed : 500,
        margin:10,
        paginationSpeed : 400,
        autoplay:true,
        items : 1, 
        itemsDesktop : false,
        itemsDesktopSmall : false,
        itemsTablet: false,
        itemsMobile : false,
        loop:true,
        nav:true,
        navText: ["<i class='fa fa-angle-left' aria-hidden='true'></i>","<i class='fa fa-angle-right' aria-hidden='true'></i>"]
    });
    $(function() {
        var owl = $('.owl-carousel'),
            owlOptions = {
                loop: false,
                margin: 10,
                responsive: {
                    0: {
                        items: 1
                    }
                }
            };
    
   });

    // add and remove active class
    $(function() {
        $('.all_diff_clr li a').click(function(e) {
            e.preventDefault();
            $('.all_diff_clr li a').not(this).removeClass('active');
            $(this).addClass('active');
        });
    });

    // dynamically adding classes in loop
    var i = 0;
    $('.main_outter_div').find('.press_blog_page_sec_left').each(function(){
        if(i<2){
            i++;    
        }else{
            i = 1;
        }
        $(this).addClass('blog_txt_right-' + i);
    });

    // dynamically adding classes in loop
    var a = ['btn_color_black','btn_color_red', 'btn_color_orange','btn_color_grey','btn_color_drakgrey']
    var num_cun = 0
    $('.color-picker-variant1').each(function(i, el){
    $(this).addClass(a[num_cun])
    if(num_cun < (a.length -1))
        num_cun++; 
    else
        num_cun = 0;
    });

    var c = ['txt_alin_left1', 'txt_alin_left2','txt_alin_left3','txt_alin_left4']
    var counter = 0
    $('.bazaar_head').each(function(i, el){
    $(this).addClass(c[counter])
    if(counter < (c.length -1))
        counter++;
    else
        counter = 0;
    }); 
 
    // making description in short length of text
    $(".quick_desc").each(function(i){
        len=$(this).text().length;
        if(len>160)
        {
          $(this).text($(this).text().substr(0,160)+'…');
        }
    });
    
    function test(){
        var options = document.getElementsByTagName('li');
        var selIndex = document.getElementById("sort_by_new").selectedIndex
        
        for (var i = 0, length = options.length; i < length; i++) {
             if(i==selIndex)
               options[i].style.backgroundColor = 'red';
             else
               options[i].style.backgroundColor = 'white';
        }
    };

   

    if ( $(window).width() < 768 ) {
        document.getElementById("sort_by").size = "1";
    }else{
        document.getElementById("sort_by").size = "6";
    }
    $(window).resize(function() {
        if ( $(window).width() <= 768 ) {
            document.getElementById("sort_by").size = "1";
        } else { 
            document.getElementById("sort_by").size = "6";
        }
    });
    
});


$('.quick_view_pro').click(function(e){
    $('.variant_cus_product_price_1').addClass('active');
    $('.color-div:first-child').addClass('active');
    // console.log($('.single-img-outer').find('.img_featured_collection').attr("alt") == $('.single-img-outer').first().find('.img_featured_collection').attr("alt"));
    $('.single-img-outer').css({"display":"none"});
    $('.single-img-outer').each(function(){
        if($(this).find('.img_featured_collection').attr("alt") == $('.single-img-outer').first().find('.img_featured_collection').attr("alt")){
            $(this).closest('.single-img-outer').css({"display":"block"});
            variant_id = $(".color-picker-variant").attr("data-first-variant-id");
            console.log("if statement",variant_id)
        }
        else{
            $(this).closest('.single-img-outer').css({"display":"none"});
            //variant_id = $("#hiddenVariantId").attr("data-add-to-cart-normal");
            console.log("if statement no")
        }
    });
});

//color picker classes dynamically
function getClassStartsWith(t,n){var r=$.grep(t.split(" "),function(t,r){return 0===t.indexOf(n)}).join();return r||!1}

$('.color-picker-variant').each(function(){
    if($('.color-picker-variant[class^="#"]')){
        // console.log($(this).attr('class'));
        var $element = $(this);
        var classes = $element[0].className;
        var getHeight = getClassStartsWith(classes,'#');
        $(this).css({"background-color":getHeight});   
    }
}); 

//var variant_id = '';
$('.color-picker-variant').on('click',function(e){
   
    $('.variant_cus_product_price_1').removeClass('active');
    $('.variant_cus_product_price').removeClass('active');
    variant_id = $(this).attr('value');
    $('#CartCount_addcart_' + this.dataset.firstVariantId).attr('data-variant-id', variant_id);
    
    $('#'+variant_id).addClass('active');
    
    var a = $(this).attr('color');
    var b = "this is "+a+" tag";
    
    $('.color-div').each(function(){
        $(this).removeClass('active');
    });
    $(this).addClass('active');

    $('.single-img-outer').css({"display":"none"});
    $('.single-img-outer').each(function(){
        //console.log($(this).find('.img_featured_collection').attr("alt") == b);
        if($(this).find('.img_featured_collection').attr("alt") == b){
            $(this).closest('.single-img-outer').css({"display":"block"});
        }
        else{
            $(this).closest('.single-img-outer').css({"display":"none"});
        }
    });
    
});



$('.quantity-picker-variant').on('click',function(){
    //console.log($(this).attr('quantity'));
    variant_id = $(this).attr('value');
  
    $('.quantity-div').each(function(){
        $(this).removeClass('active');
    });
    $(this).addClass('active');
});



 
// add to cart ajax call
$(".js-add-to-cart-ajax").click(function () {
    if($(this).find('span').hasClass('span-text')) {
        $(this).find('span').css({'visibility':"hidden"});
        $(this).find('.load-3p').css({"display":"block"});
        window.location.href = '/cart';
    } else {
        $(this).find('span').addClass('span-text');
        $(this).find('span').html('go to cart <i class="fa fa-long-arrow-right arrow1" aria-hidden="true"></i>');
        let data = { 
            quantity: 1, 
            id: this.dataset.variantId
        } 
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',  
            data: data,
            success: function(response) {
                $("#success_ajax_cart li").html('');
                $("#success_ajax_cart li").html('Item added to your bag | <a href="/cart">View Cart</a>');
                $("#success_ajax_cart").show();
                setTimeout(function() {
                    $("#success_ajax_cart").hide();
                }, 7000);
                $('.modal').each(function(){
                    $(this).modal('hide');
                });
                $.getJSON('/cart/update.js', function(cart) {
                    console.log(cart.item_count);
                    $(".num_count").each(function(){
                        $(this).html(cart.item_count ); 
                    });
                });
            },
            error:function(err){
            // console.log(err);
            }
        
        });  
    }
    
});   



function changeImage(that){
    $(that).find('img').attr('src', 'https://cdn.shopify.com/s/files/1/0276/3836/6317/files/Wishlist.svg');
   // console.log('that is working');
    $(that).closest('.wishlist_icon').css({"opacity":"1"});
}

// $('.wishlist-icon').on('click',function(){
//     $(this).css({"opacity":"1"});
//     $(this).find('img').attr('src', 'https://cdn.shopify.com/s/files/1/0276/3836/6317/files/Wishlist.svg?22203');
// });


function inner3Col(video_req=true){
    let productList = document.getElementById("product-list");
    if (!productList) {
        return
    }
    let items = productList.getElementsByClassName("inner_coll_one_wrap");
    let currentIndex = 0;
    let breakingStep = 2;
    let breakingIndex = 1;
    //let rand_id = Math.floor((Math.random()*10)+1);
    //console.log(rand_id,'hi');
    for(let i=0; i<items.length; i++) {
        currentIndex = i;
        if(breakingStep === 3) {
            var Idno = items[i];
            $(Idno).addClass('inner_coll_two_wrap');
        }
        if((currentIndex) == breakingIndex){ 
            if(breakingStep == 2) {
                breakingStep = 3;
            } else {
                breakingStep = 2;
            }
            breakingIndex = currentIndex + breakingStep;
        }
        // console.log(i)

        if(i === 6 && video_req) {
            let content = '<div class="product-video">'
            content += '<img src="' + YOUTUBE_THUMBNAIL + '" width="100%" />'
            content += '<a href="' + YOUTUBE_VIDEO + '" class="js-play-btn-videos">'
            content += '<div class="video_btn" id="js-video-btn">'
            content += '<img src=" '+YOUTUBE_PLAYBUTTON+' " alt="" />'
            content += '</div></a></div>'

            items[i].insertAdjacentHTML("afterend", content);
            video_popup();
        }else{
            $("img[src='']").parent(".product-video").addClass("d-none");
        }
    }
}



function video_popup(){
    $('.js-play-btn-videos').magnificPopup({
        type: 'iframe', 
        iframe: {
            markup: '<div class="mfp-iframe-scaler">' +
                '<div class="mfp-close"></div>' +
                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
    
            patterns: {
                youtube: {
                    index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).
    
                    id: 'v=', // String that splits URL in a two parts, second part should be %id%
                    // Or null - full URL will be returned
                    // Or a function that should return %id%, for example:
                    // id: function(url) { return 'parsed id'; }
    
                    src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0' // URL that will be set as a source for iframe.
                },
                vimeo: {
                    index: 'vimeo.com/',
                    id: '/',
                    src: '//player.vimeo.com/video/%id%?autoplay=1'
                },
                gmaps: {
                    index: '//maps.google.',
                    src: '%id%&output=embed'
                }
    
                // you may add here more sources
    
            },
    
            srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        }
    });
}

$('.video_btn').on('click',function(){
    console.log('this is video about us');
    $('.js-play-btn-videos-about').magnificPopup({
        type: 'iframe', 
        iframe: {
            markup: '<div class="mfp-iframe-scaler">' +
                '<div class="mfp-close"></div>' +
                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
    
            patterns: {
                youtube: {
                    index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).
    
                    id: 'v=', // String that splits URL in a two parts, second part should be %id%
                    // Or null - full URL will be returned
                    // Or a function that should return %id%, for example:
                    // id: function(url) { return 'parsed id'; }
    
                    src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0' // URL that will be set as a source for iframe.
                },
                vimeo: {
                    index: 'vimeo.com/',
                    id: '/',
                    src: '//player.vimeo.com/video/%id%?autoplay=1'
                },
                gmaps: {
                    index: '//maps.google.',
                    src: '%id%&output=embed'
                }
    
                // you may add here more sources
    
            },
    
            srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        }
    });
})

// ajax pagination for next page
function nextPage(that) {
    $.ajax({
        type: "GET",
        url: that.dataset.nextPage,
        success: (response) => {
            let parser =  new DOMParser().parseFromString(response, 'text/html');
            $('div#AjaxinateLoop').append(parser.getElementById('AjaxinateLoop').innerHTML);
            parser.getElementById('loadNextPage') ? $('div#loadNextPage').html(parser.getElementsByClassName('load-more-wrapper')[0].innerHTML): $('div.load-more-wrapper').remove();
            inner3Col(false);
            ASYNC = false
        },
      });
    return false
}

ASYNC = false;

$(window).bind('scroll', () => {
    if ($('#AjaxinateLoop').length > 0 && $(this).scrollTop() > $('#AjaxinateLoop')[0].scrollHeight && ASYNC === false) {
        ASYNC = true
       $('#autoLoadMore').click();
        return false
    }
})




$(document).ready(function () {
    initialize_owl($('#owl_bestseller-0'));
  
    let tabs = [
        { target: '#tab-0', owl: '#owl_bestseller-0' },
        { target: '#tab-1', owl: '#owl_bestseller-1' },
        { target: '#tab-2', owl: '#owl_bestseller-2' },
    ];

    // Setup 'bs.tab' event listeners for each tab
    // $('.owl-bestseller').on('click', function() {
    //     destroy_owl($(this))
    //     console.log(this)
    // })
    tabs.map((tab) => {
        $('a[href="' + tab.target + '"')
        .on('shown.bs.tab', function() {
            initialize_owl($(tab.owl))
            $('.owl-bestseller').not($($(this.attributes.href.value).children()[0])).map(function() {
                $(this).owlCarousel('destroy') 
            })
        })
    });  
  });
  

function initialize_owl(el) {
    el.owlCarousel({
        loop: true,
        margin: 10,
        item:3,
        responsiveClass: true,
        touchDrag  : true,
        mouseDrag  : true,
        responsive: {
            0: {
            items: 1,
            nav: true
            },
            600: {
            items: 2,
            nav: false
            },
            1000: {
            items: 3,
            nav: true,
            loop: false
            }
        }
    });
  }
  
  function destroy_owl(el) {
    el.owlCarousel('destroy')
  }
  wow = new WOW({
    animateClass: 'animated',
    offset:       100,
    callback:     function(box) {
        console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
    }
});




$(document).ready(function() {
	
	// If the comparison slider is present on the page lets initialise it, this is good you will include this in the main js to prevent the code from running when not needed
	if ($(".comparison-slider")[0]) {
		let compSlider = $(".comparison-slider");
	
		//let's loop through the sliders and initialise each of them
		compSlider.each(function() {
			let compSliderWidth = $(this).width() + "px";
			$(this).find(".resize img").css({ width: compSliderWidth });
            console.log(compSliderWidth)
			drags($(this).find(".divider"), $(this).find(".resize"), $(this));
		});

		//if the user resizes the windows lets update our variables and resize our images
		$(window).on("resize", function() {
			let compSliderWidth = compSlider.width() + "px";
			compSlider.find(".resize img").css({ width: compSliderWidth });
		});
	}
});

// This is where all the magic happens
// This is a modified version of the pen from Ege Görgülü - https://codepen.io/bamf/pen/jEpxOX - and you should check it out too.
function drags(dragElement, resizeElement, container) {
	// This creates a variable that detects if the user is using touch input insted of the mouse.
	let touched = false;
	window.addEventListener('touchstart', function() { touched = true });
	window.addEventListener('touchend', function() { touched = false });
	// clicp the image and move the slider on interaction with the mouse or the touch input
	dragElement.on("mousedown touchstart", function(e) {
		//add classes to the emelents - good for css animations if you need it to
		dragElement.addClass("draggable");
		resizeElement.addClass("resizable");

		//create vars
		let startX = e.pageX ? e.pageX : e.originalEvent.touches[0].pageX;
		let dragWidth = dragElement.outerWidth();
		let posX = dragElement.offset().left + dragWidth - startX;
		let containerOffset = container.offset().left;
        let containerWidth = container.outerWidth();

        const deviceConstant = getDeviceConstant()
        console.log(deviceConstant,"deviceConstantsjsjn");
        let minLeft = containerOffset + deviceConstant;
        let maxLeft = containerOffset + containerWidth - dragWidth - deviceConstant;

		//add event listner on the divider emelent
		dragElement.parents().on("mousemove touchmove", function(e) {
		  // if the user is not using touch input let do preventDefault to prevent the user from slecting the images as he moves the silder arround.
			if ( touched === false ) {
                // Enable Slick
				e.preventDefault();
			}
				
			let moveX = e.pageX ? e.pageX : e.originalEvent.touches[0].pageX;
			let leftValue = moveX + posX - dragWidth;

			// stop the divider from going over the limits of the container
			if (leftValue < minLeft) {
				leftValue = minLeft;
			} else if (leftValue > maxLeft) {
				leftValue = maxLeft;
			}

			let widthValue = (leftValue + dragWidth / 2 - containerOffset) * 100 / containerWidth;

			$(".draggable").css("left", widthValue + "%").on("mouseup touchend touchcancel", function() {
				$(this).removeClass("draggable");
				resizeElement.removeClass("resizable");
			});

            // Use Linear regeration to solve scroll and resizable issue for before and after
            // y = mx + c equation
            // m = 1.407 calculated based on .slide_divider width
            // c = -19.595 based on .slide_divider width
            widthValue = (1.4070422535 * widthValue) - 19.595
			$(".resizable").css("width", (widthValue + "%"));
				
		}).on("mouseup touchend touchcancel", function() {
			dragElement.removeClass("draggable");
			resizeElement.removeClass("resizable");
		});
        // Disable Slick
        $('#slider-before-after').slick("slickSetOption", "swipe", false);
		
	}).on("mouseup touchend touchcancel", function(e) {
		// stop clicping the image and move the slider
		dragElement.removeClass("draggable");
		resizeElement.removeClass("resizable");
        $('#slider-before-after').slick("slickSetOption", "swipe", true);
	});
}

function getDeviceConstant() {
    const windowSize = $(window).width()
    if (windowSize.inRange(0, 320)) {
        return 35
    } else if (windowSize.inRange(320, 375)) {
        return 48
    } else if (windowSize.inRange(375, 425)) {
        return 50
    } else if (windowSize.inRange(425, 768)) {
        return 60
    } else if (windowSize.inRange(768, 1440)) {
        return 75
    } else if (windowSize.inRange(1440, 1920)) {
        return 75
    } else {
        return 75
    }
}

Number.prototype.inRange = function(min, max) {
    return min<this&this<=max
}

